import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ITenant, Tenant} from 'app/blocks/model/tenant.model';
import {TenantService} from 'app/blocks/service/api/tenant.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SUPER_ADMIN_SETUP_BASE_URL} from 'app/app.constants';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class TenantResource extends AbstractEntityResource<ITenant> {
    constructor(tenantService: TenantService, router: Router) {
        super(
            Resource.TENANTS,
            tenantService,
            new EntityNavigator(ENTITIES_SUPER_ADMIN_SETUP_BASE_URL, Resource.TENANTS, router),
            new EntityUrlProvider(ENTITIES_SUPER_ADMIN_SETUP_BASE_URL, Resource.TENANTS),
            (entity?) => new Tenant(entity),
            (entity) => entity.id
        );
    }
}
